export function HomeLocationDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Home & Location Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Event Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Type of Event <span className="text-red-500">*</span>
            </label>
            <select className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200">
              <option value="">Select event type</option>
              <option value="moving">Moving to New Home</option>
              <option value="first_purchase">First Home Purchase</option>
              <option value="relocation">City/Country Relocation</option>
              <option value="renovation">Home Renovation</option>
              <option value="neighborhood">Neighborhood Change</option>
            </select>
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter location"
            />
          </div>

          {/* Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Duration */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Duration of Stay
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="e.g., 2 years, 6 months"
            />
          </div>

          {/* Description */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Description
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Describe the location and its significance"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 